module.exports = __webpack_public_path__ + "img/EXTERIOR-IGNIS-3.13c2c3bf.jpg";